import { createFileRoute } from "@tanstack/react-router";

import { validateAuthToken } from "@/guards/validateAuthToken";
import { validateActiveUser } from "@/guards/validateActiveUser";

import { StateMessageFactory } from "@/components/shared/state-messages/StateMessageFactory";

export const Route = createFileRoute("/dashboard/error/generic-error")({
  beforeLoad: () => {
    validateAuthToken();
    validateActiveUser();
  },
  component: GenericError,
});

function GenericError() {
  return (
    <div className="mt-12 2xl:mt-24 mx-auto xl:max-w-4/5 2xl:max-w-3/5">
      {StateMessageFactory("generic-error")}
    </div>
  );
}
